/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";
import styled from "styled-components";

import {WealthyEnv} from "helpers";
import {colors} from "nxtconstants";

import {
  container
} from "../common";
import {GetStartedModal} from "components/commons";

const GetStartedSection = ({
  setToggleModal,
  toggleModal
}) => {
  return (
    <>
      <GetStartedContainer>
        <GetStartedContent>
          <Tagline>
          💎 <LineBreak />Value Packed Pricing  <LineBreak>|</LineBreak> <HighLight>No Hidden Charges</HighLight>
          </Tagline>
          <CtaButton type="button" onClick={() => setToggleModal(!toggleModal)}>
            Get started
          </CtaButton>
        </GetStartedContent>
      </GetStartedContainer>
      <GetStartedModal
        setToggleModal={setToggleModal}
        toggleModal={toggleModal}
      />
    </>
  );
};

const GetStartedContainer = styled(container)`
  margin: 10rem auto;

  @media (max-width: 576px) {
    margin: 3.3rem auto;
    margin-left: 2rem;
    margin-right: 2rem;
    padding-bottom: 1.7rem;
  }
`;

const GetStartedContent = styled.div`
  display: flex;
  align-items: center;
  margin: 0 auto;
  border-radius: 100px;
  background-color: ${colors.white};
  border: 1px solid #DDD;
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.10);
  padding: 2rem;

  @media (max-width: 768px) { 
    display: block;
    text-align: center;
    border-radius: 1.6rem;
  }

  @media (max-width: 576px) {
    display: block;
    border-radius: 16px;
    text-align: center;
  }
`;

const Tagline = styled.h2`
  font-size: 3.2rem;
  font-weight: 400;
  margin-right: auto;
  padding-left: 4rem;

  @media (max-width: 768px) {
    font-size: 2rem;
    padding-left: unset;
  }
`;

const LineBreak = styled.span`
  @media (max-width: 576px) { 
    display: block;
    height: 0;
    overflow: hidden;
  }
`;

const HighLight = styled.span`
  color: ${colors.rajah};
`;

const CtaButton = styled.button`
  font-size: 1.8rem;
  background-color: ${colors.primary};
  color: ${colors.white};
  padding: 1.7rem 4.4rem;
  display: inline-block;
  border: none;
  border-radius: 100px;
  transition: all 0.15s ease-in-out;
  width: 300px;
  text-align: center;
  font-weight: 700;
  cursor: pointer;
  font-family: inherit;

  &:hover {
    transform: translateY(-4px);
  }

  @media (max-width: 768px) {
    margin-top: 3.2rem;
    padding: 1.2rem 4.4rem;
  }

  @media (max-width: 576px) {
    font-size: 1.6rem;
    width: 100%;
  }
`;

export default GetStartedSection;
